// src/components/SkeletonComponents.jsx
import React from 'react';

export const SkeletonShimmer = ({ width, height, borderRadius = '8px', style = {} }) => (
  <div
    style={{
      width: width || '100%',
      height: height || '20px',
      borderRadius,
      background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
      backgroundSize: '400px 100%',
      animation: 'shimmer 1.5s ease-in-out infinite',
      ...style,
    }}
  />
);

export const SkeletonCard = ({ width = '160px', height = '200px', showLabel = true }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', flexShrink: 0 }}>
    <SkeletonShimmer width={width} height={height} borderRadius="16px" />
    {showLabel && <SkeletonShimmer width={width} height="14px" borderRadius="10px" />}
  </div>
);

export const SkeletonAssetGrid = ({ count = 6, columns = 2 }) => (
  <div style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: '8px' }}>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonShimmer key={i} height="100%" style={{ aspectRatio: '1/1' }} borderRadius="8px" />
    ))}
  </div>
);

export const SkeletonCatalogGrid = ({ count = 12, columns = 4 }) => (
  <div style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: '16px' }}>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonShimmer key={i} height="100%" style={{ aspectRatio: '4/3' }} borderRadius="12px" />
    ))}
  </div>
);

export const SkeletonHorizontalCards = ({ count = 4 }) => (
  <div style={{ display: 'flex', gap: '16px' }}>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} width="160px" height="200px" />
    ))}
  </div>
);